import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule from './auth'
import CommonModule from './common'
import UserModule from './user'
import ParishModule from './parish'
import ChatModule from './chat'
import ConferenceModule from './conference'
import BlogModule from './blog'
import ShriftModule from './shrift'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    AuthModule,
    CommonModule,
    UserModule,
    ParishModule,
    ChatModule,
    ConferenceModule,
    BlogModule,
    ShriftModule
  },
  strict: debug
})
